
import { Component, Vue } from "vue-property-decorator";

const ACTIONS_BUTTON_INIT_TIMEOUT = 500;

const CLASS = "main";

@Component({
  components: {
    AppMainToolbar: () => import("./AppMainToolbar.vue"),
    AppNotification: () => import("@/components/V2/AppNotification/AppNotification.vue"),
  },
})
export default class AppMain extends Vue {
  get hideToolbar() {
    return !!this.$route.meta.hideToolbar;
  }

  get isPortalIframeRoute() {
    return Boolean(this.$route.meta.portalPath);
  }

  stickyToolbar = false;

  handleScroll(e: any) {
    this.stickyToolbar = e.target.scrollTop > 0;
  }

  get classes() {
    return {
      [`${CLASS}_new`]: true,
      [`${CLASS}_portal-iframe`]: this.isPortalIframeRoute,
    };
  }

  created() {
    this.$nextTick(() => {
      const target = this.$refs.view as HTMLElement;

      if (!target) return;

      target.addEventListener("scroll", this.handleScroll);
    });
  }

  mounted() {
    setTimeout(() => {
      this.portalActionButtonsShown = true;
      this.actionButtonsInit = true;
    }, ACTIONS_BUTTON_INIT_TIMEOUT);
  }

  destroyed() {
    const target = this.$refs.view as HTMLElement;

    if (!target) return;

    target.removeEventListener("scroll", this.handleScroll);
  }

  portalActionButtonsShown = false;
  actionButtonsInit = false;

  get actionButtonsIsInit() {
    return this.portalActionButtonsShown || this.actionButtonsInit;
  }

  handleActionUpdate(bool: boolean) {
    this.portalActionButtonsShown = bool;
  }
}
